import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    TASK_EMPLOYEE_LIST,
    TASK_EMPLOYEE_ADD,
    TASK_EMPLOYEE_UPDATE
} from '../actions';
import {
    TaskEmployeeListSuccess,
    TaskEmployeeListError,
    TaskEmployeeAddSuccess,
    TaskEmployeeAddError,
    TaskEmployeeUpdateSuccess,
    TaskEmployeeUpdateError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST
const onTaskEmployeeListAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task_employee/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskEmployeeList(action) {
    try {
        const response = yield call(onTaskEmployeeListAsync, action.payload);
        yield put(TaskEmployeeListSuccess(response.data.data));
    } catch (error) {
        yield put(TaskEmployeeListError(error));
    }
}

// ADD
const onTaskEmployeeAddAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task_employee/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskEmployeeAdd(action) {
    try {
        const response = yield call(onTaskEmployeeAddAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(TaskEmployeeAddSuccess(response.data.id));
    } catch (error) {
        yield put(TaskEmployeeAddError(error));
        NotificationManager.error('Error al agregar empleado a la tarea', 'Error', 3000, null, null, '');
    }
}

// UPDATE
const onTaskEmployeeUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task_employee/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskEmployeeUpdate(action) {
    try {
        const response = yield call(onTaskEmployeeUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else {
            NotificationManager.error(response.data.message || 'Error', 'Error', 3000, null, null, '');
        }
        yield put(TaskEmployeeUpdateSuccess(response.data));
    } catch (error) {
        yield put(TaskEmployeeUpdateError(error));
        NotificationManager.error('Error al actualizar empleado de la tarea', 'Error', 3000, null, null, '');
    }
}

function* watchTaskEmployeeList() { yield takeEvery(TASK_EMPLOYEE_LIST, onTaskEmployeeList); }
function* watchTaskEmployeeAdd() { yield takeEvery(TASK_EMPLOYEE_ADD, onTaskEmployeeAdd); }
function* watchTaskEmployeeUpdate() { yield takeEvery(TASK_EMPLOYEE_UPDATE, onTaskEmployeeUpdate); }

export default function* rootSaga() {
    yield all([
        fork(watchTaskEmployeeList),
        fork(watchTaskEmployeeAdd),
        fork(watchTaskEmployeeUpdate)
    ]);
}
